import React from "react";
import { useCloseOnEscape } from "shared/utils";

import { StyledOverlayProps, StyledOverlay } from "./styles";

interface OverlayProps extends StyledOverlayProps {
  onClick: () => void;
}

export const Overlay: React.FC<OverlayProps> = ({
  hasBackground,
  onClick,
  children,
}) => {
  useCloseOnEscape(onClick);

  return (
    <StyledOverlay hasBackground={hasBackground} onClick={onClick}>
      {children}
    </StyledOverlay>
  );
};
